(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.AssetPicker = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) {/**/}

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0],
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	} else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = target[name];
				copy = options[name];

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[name] = extend(deep, clone, copy);

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						target[name] = copy;
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


},{}],2:[function(require,module,exports){
var containers = []; // will store container HTMLElement references
var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}

module.exports = function (css, options) {
    options = options || {};

    var position = options.prepend === true ? 'prepend' : 'append';
    var container = options.container !== undefined ? options.container : document.querySelector('head');
    var containerId = containers.indexOf(container);

    // first time we see this container, create the necessary entries
    if (containerId === -1) {
        containerId = containers.push(container) - 1;
        styleElements[containerId] = {};
    }

    // try to get the correponding container + position styleElement, create it otherwise
    var styleElement;

    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
        styleElement = styleElements[containerId][position];
    } else {
        styleElement = styleElements[containerId][position] = createStyleElement();

        if (position === 'prepend') {
            container.insertBefore(styleElement, container.childNodes[0]);
        } else {
            container.appendChild(styleElement);
        }
    }

    // actually add the stylesheet
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText += css
    } else {
        styleElement.textContent += css;
    }

    return styleElement;
};

function createStyleElement() {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    return styleElement;
}

},{}],3:[function(require,module,exports){
module.exports = '.assetpicker-modal {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0);\n    z-index: -1;\n    transition: background 0.2s, z-index 0s 0.2s;\n}\n.assetpicker-modal.assetpicker-modal-open {\n    z-index:3000;\n    background: rgba(0, 0, 0, 0.8);\n    transition: background 0.2s\n}\n.assetpicker-modal .assetpicker-modal-inner {\n    position: absolute;\n    background: #fff;\n    width: 800px;\n    height: 500px;\n    max-width: calc(100% - 30px);\n    max-height: calc(100% - 30px);\n    left:50%;\n    top:50%;\n    transform: translateY(-50%) translateX(-50%);\n    opacity: 0;\n    transition: opacity 0.1s 0.1s;\n    border-radius: 4px;\n    overflow: hidden;\n}\n.assetpicker-modal.assetpicker-maximized .assetpicker-modal-inner {\n    width: 100%;\n    height: 100%;\n}\n.assetpicker-modal.assetpicker-modal-open .assetpicker-modal-inner {\n    opacity: 1;\n}\n.assetpicker-modal .assetpicker-modal-inner iframe {\n    position: absolute;\n    background: transparent;\n    top:0;\n    left:0;\n    width:100%;\n    height: 100%;\n    overflow: hidden;\n    border: none;\n}\n\n.assetpicker-loader {\n    border: 5px solid gray;\n    border-radius: 30px;\n    height: 30px;\n    left: 50%;\n    margin: -15px 0 0 -15px;\n    opacity: 0;\n    position: absolute;\n    top: 50%;\n    width: 30px;\n\n    animation: assetpicker-loader-pulsate 1s ease-out;\n    animation-iteration-count: infinite;\n}\n.assetpicker-ready .assetpicker-loader {\n    display: none;\n    animation: none;\n}\n\n@keyframes assetpicker-loader-pulsate {\n    0% {\n        transform: scale(.1);\n        opacity: 0.0;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1.2);\n        opacity: 0;\n    }\n}';
},{}],4:[function(require,module,exports){
module.exports = '<div class="assetpicker-modal">\n    <div class="assetpicker-modal-inner">\n        <div class="assetpicker-loader"></div>\n        <iframe src="about:blank" allowtransparency="true">\n            Ehm, without iframes i ain\'t do nothing.\n        </iframe>\n    </div>\n</div>\n';
},{}],5:[function(require,module,exports){
var extend = require('extend'),
    util = require('../../util'),
    insertCss = require('insert-css'),
    transitionEvent = (function() {
        var el = document.createElement('div');
        var transitions = {
            'transition': 'transitionend',
            'OTransition': 'otransitionend',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };
        for (var i in transitions) {
            if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
                return transitions[i];
            }
        }
    })(),
    hasTransitions = function(element) {
        var css = window.getComputedStyle(element, null);
        var transitionDuration = ['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'];
        var hasTransition = transitionDuration.filter(function (i) {
            if (typeof css[i] === 'string' && css[i].match(/[1-9]/)) {
                return true;
            }
        });
        return hasTransition.length ? true : false;
    },
    Messaging = require('../../../shared/util/messaging');

module.exports = require('../../../shared/util/createClass')({
    construct: function (options) {
        this.options = extend(
            {
                template: require('./index.html'),
                css: require('./index.css'),
                openClassName: 'assetpicker-modal-open',
                src: null
            },
            options
        );
        this.modal = null;
        this.frame = null;

        var matches = this.options.src.match(/^https?:\/\/[^\/]+/);
        this.messaging = new Messaging(matches ? matches[0] : document.location.origin)
    },
    render: function() {
        if (this.options.css) {
            insertCss(this.options.css);
        }
        var div = document.createElement('div');
        div.innerHTML = this.options.template;
        this.modal = div.children[0];
        this.modal.addEventListener('click', function(event) {
            if (event.target === this.modal) {
                this.close();
            }
        }.bind(this));
        this.frame = this.modal.querySelector('iframe');
        document.body.appendChild(this.modal);
        this._modalClass = this.modal.className;
    },
    open: function() {
        if (!this.modal) {
            this.render();
            var that = this;
            this.frame.src = this.options.src;
            window.setTimeout(function() { that.open(); }, 1);
            return;
        }
        this.messaging.window = this.frame.contentWindow;
        util.addClass(this.modal, this.options.openClassName);
    },
    maximize: function () {
        util.addClass(this.modal, 'assetpicker-maximized');
    },
    minimize: function () {
        util.removeClass(this.modal, 'assetpicker-maximized');
    },
    _closed: function() {
    },
    close: function() {
        if (transitionEvent && hasTransitions(this.modal)) {
            var closeTransitionHandler = function () {
                this.modal.removeEventListener(transitionEvent, closeTransitionHandler);
                this._closed();
            }.bind(this);
            this.modal.addEventListener(transitionEvent, closeTransitionHandler);
        } else {
            this._closed();
        }
        util.removeClass(this.modal, this.options.openClassName);
    }
});

},{"../../../shared/util/createClass":9,"../../../shared/util/messaging":10,"../../util":8,"./index.css":3,"./index.html":4,"extend":1,"insert-css":2}],6:[function(require,module,exports){
var cssLoaded = false;
var extend = require('extend');
var util = require('../../util');

module.exports = require('../../../shared/util/createClass')({
    construct: function (element, picker) {
        if (!cssLoaded) {
            util.loadCss(picker.getDistUrl() + '/css/picker-ui.css');
        }

        this.config = extend(
            {
                unique: true,
                readonly: false
            },
            picker.options.ui,
            {
                readonly: element.hasAttribute('data-ro') ? ['false', '0'].indexOf(element.getAttribute('data-ro')) === -1 : undefined,
                unique: element.hasAttribute('data-unique') ? ['false', '0'].indexOf(element.getAttribute('data-unique')) === -1 : undefined
            }
        );

        this.add = false;
        this.propagate = false;
        this.picker = picker;
        this.element = element;
        var value = element.hasAttribute('value') ? element.getAttribute('value') : undefined;
        if (value) {
            try {
                this.picked = JSON.parse(value);
            } catch (e) {
                this.picked = [];
                console.error('Error while parsing value of %s', element);
            }
        } else {
            this.picked =[];
        }
        if (this.picked.constructor !== Array) {
            this.picked = [this.picked];
        }
        this.render();

        var that = this;
        picker.on('pick', function (picked) {
            if (!that.propagate && this.element === element) {
                var pickedArr = picked.constructor !== Array ? [picked] : picked;
                if (that.add) {
                    for (var i = 0; i < pickedArr.length; i++) {
                        var contains = false;
                        if (that.config.unique) {
                            for (var j = 0; j < that.picked.length; j++) {
                                if (that.picked[j].storage === pickedArr[i].storage && that.picked[j].id === pickedArr[i].id) {
                                    contains = true;
                                    break;
                                }
                            }
                        }
                        if (!contains) {
                            that.picked.push(pickedArr[i]);
                        }
                    }
                    pickedArr = that.picked;
                }
                that.pick(pickedArr);
                return false;
            }
            that.propagate = false;
            that.add = false;
        });
    },
    pick: function (picked) {
        this.picked = picked;
        this.propagate = true;
        this.picker.element = this.element;
        this.picker.pick(this.picker._getPickConfig(this.element).limit === 1 ? (picked.length ? picked[0] : undefined) : picked);
        this.render();
    },
    createElement: function (name, className) {
        var element = document.createElement(name);
        element.className = 'assetpicker-' + className.split(' ').join(' assetpicker-');
        return element;
    },
    render: function () {
        if (!this.container) {
            this.container = this.element.parentNode.insertBefore(this.createElement('div', 'ui'), this.element);
            this.element.parentNode.removeChild(this.element);
        }
        this.container.innerHTML = '';
        this.renderItems(this.picked);
        util[(this.picked.length || this.config.readonly ? 'add' : 'remove') + 'Class'](this.element, 'assetpicker-hidden');
        this.container.appendChild(this.element);

        if (this.picked.length && !this.config.readonly) {
            var limit = this.picker._getPickConfig(this.element).limit;
            if (limit === 0 || limit !== 1 && this.picked.length < limit) {
                this.container.appendChild(this.createElement('span', 'add')).addEventListener('click', function (e) {
                    this.add = true;
                    this.element.setAttribute('data-limit', limit - this.picked.length);
                    this.picker.open(this.element);
                    this.element.setAttribute('data-limit', limit);
                }.bind(this));
            }
        }
    },
    renderItems: function (picked) {
        for (var i = 0, l = picked.length; i < l; i++) {
            var item = this.container.appendChild(this.createElement('div', 'item'));
            var preview = item.appendChild(this.createElement('div', 'preview'));
            var mediaType = extend({name: 'file'}, picked[i].mediaType);
            var fileTypeClass = 'ft ft-' + mediaType.name;
            preview.appendChild(this.createElement('div', fileTypeClass));
            if (mediaType.iconBig) {
                preview.appendChild(this.createElement('div', 'icn')).style.backgroundImage = 'url(' + mediaType.iconBig + ')';
            }
            if (picked[i].thumbnail) {
                preview.appendChild(this.createElement('div', 'tn ' + mediaType.name)).style.backgroundImage = 'url(' + picked[i].thumbnail + ')';
            }
            if (!this.config.readonly) {
                preview.appendChild(this.createDeleteButton(picked[i]));
            }
            var title = item.appendChild(this.createElement('div', 'title'));
            if (mediaType.icon) {
                title.appendChild(this.createElement('img', 'icn')).src = mediaType.icon;
            } else {
                title.appendChild(this.createElement('span', fileTypeClass));
            }
            title.appendChild(document.createTextNode(picked[i].name));
        }
    },
    createDeleteButton: function (item) {
        var button = this.createElement('span', 'del');
        button.addEventListener('click', function () {
            var picked = [];
            for (var i = 0, l = this.picked.length; i < l; i++) {
                if (this.picked[i] !== item) {
                    picked.push(this.picked[i]);
                }
            }
            this.pick(picked);
        }.bind(this));
        return button;
    }
});
},{"../../../shared/util/createClass":9,"../../util":8,"extend":1}],7:[function(require,module,exports){
var Modal = require('./components/modal');
var UI = require('./components/ui');
var uid = require('../shared/util/uid');
var extend = require('extend');

var distUrl = (function() {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1].src.split('/').slice(0, -2).join('/');
})();

module.exports = require('../shared/util/createClass')({
    construct: function(config, options) {
        this.setConfig(config);
        options = extend(
            true,
            {
                distUrl: distUrl,
                selector: '[rel="assetpicker"]',
                modal: {
                    src: null
                },
                ui: {
                    enabled: true
                }
            },
            options || {}
        );
        if (!options.modal.src) {
            options.modal.src = options.distUrl + '/index.html';
        }
        if (options.modal.src.match(/^https?:\/\/localhost/) || document.location.hostname === 'localhost') {
            options.modal.src += '?' + uid();
        }

        this.pickConfig = {};
        this.options = options;
        this.modal = null;
        this.element = null;
        this.uis = [];

        this._memoryEvents = {
            'ready': null
        };
        this._callbacks = {};

        this.on('ready', function () {
            this.modal.modal.className += ' assetpicker-ready'
        });
        this.on('resize', function (maximize) {
            this.modal[maximize ? 'maximize' : 'minimize']();
        });

        document.addEventListener('DOMContentLoaded', function () {
            var inputs = document.querySelectorAll(this.options.selector);
            for (var i = 0, l = inputs.length; i < l; i++) {
                this.register(inputs[i]);
            }
        }.bind(this));
    },
    getOrigin: function () {
        return document.location.origin;
    },
    getDistUrl: function () {
        return this.options.distUrl;
    },
    on: function (event, callback) {
        if (!this._callbacks.hasOwnProperty(event)) {
            this._callbacks[event] = [];
        }
        this._callbacks[event].push(callback);
        if (this._memoryEvents[event]) {
            callback.apply(this, this._memoryEvents[event]);
        }
        return this;
    },
    _trigger: function (event) {
        var args = Array.prototype.slice.call(arguments, 1);
        if (this._callbacks[event]) {
            this._callbacks[event].forEach(function (callback) {
                return callback.apply(this, args);
            }.bind(this));
        }
        if (this._memoryEvents.hasOwnProperty(event)) {
            this._memoryEvents[event] = args;
        }
    },
    register: function (element) {
        if (element.hasAttribute('data-assetpicker')) {
            return;
        }
        element.setAttribute('data-assetpicker', 1);
        if (element.hasAttribute('data-ui') || this.options.ui && this.options.ui.enabled) {
            this.uis.push(new UI(element, this));
        }
        element.addEventListener('click', function (event) {
            event.preventDefault();
            this.open(element);
        }.bind(this));
    },
    _getPickConfig: function (element) {
        var getSplitAttr = function (attr) {
            var value = element.getAttribute(attr);
            return value.length ? value.split(',') : []
        };
        return extend({}, this.config.pick, {
            limit: element.hasAttribute('data-limit') ? parseInt(element.getAttribute('data-limit')) : undefined,
            types: element.hasAttribute('data-types') ? getSplitAttr('data-types') : undefined,
            extensions: element.hasAttribute('data-ext') ? getSplitAttr('data-ext') : undefined
        });
    },
    getUi: function (element) {
        for (var i = 0, l = this.uis.length; i < l; i++) {
            if (this.uis[i].element === element) {
                return this.uis[i];
            }
        }
    },
    open: function (options) {
        if (// http://stackoverflow.com/a/384380, options is a HTMLElement
            typeof HTMLElement === "object" && options instanceof HTMLElement //DOM2
            || options && typeof options === "object" && options !== null && options.nodeType === 1 && typeof options.nodeName==="string") {

            this.element = options;
            this.pickConfig = this._getPickConfig(options);
        } else {
            this.element = undefined;
            this.pickConfig = extend({}, this.config.pick, options);
        }
        if (!this.modal) {
            this.modal = new Modal(this.options.modal);
            this.modal.messaging.registerServer('picker', this);
            this.on(
                'ready',
                function () {
                    this.modal.messaging.call('app.setConfig', {pick: this.pickConfig})
                }
            );
        } else {
            try {
                // When this fails, it likely means the app is not ready yet and above ready listener will handle this
                this.modal.messaging.call('app.setConfig', {pick: this.pickConfig});
            } catch (e) {}
        }
        this.modal.open();
    },
    getConfig: function() {
        return this.config;
    },
    setConfig: function (config) {
        this.config = extend(
            true,
            {
                pick: {
                    limit: 1,
                    types: ['file'],
                    extensions: []
                }
            },
            config
        );
        if (this.modal) {
            picker.modal.messaging.call('app.setConfig', this.config);
        }
    },
    pick: function(picked) {
        if (this.element) {
            var tagName = this.element.tagName.toLowerCase();
            if (tagName === 'input' && this.element.getAttribute('type') === 'button' || tagName === 'button') {
                this.element.setAttribute('value', picked ? JSON.stringify(picked) : '');
            }
        }
        this._trigger('pick', picked);
        if (this.modal) {
            this.modal.close();
        }
    }
});

},{"../shared/util/createClass":9,"../shared/util/uid":11,"./components/modal":5,"./components/ui":6,"extend":1}],8:[function(require,module,exports){
module.exports = {
    addClass: function (element, className) {
        if (element.className) {
            if (element.className.split(' ').indexOf(className) === -1) {
                element.className += ' ' + className;
            }
        } else {
            element.className = className;
        }
    },
    removeClass: function (element, className) {
        if (element.className) {
            var classNames = element.className.split(' '), newClassNames = [];
            for (var i = 0, l = classNames.length; i < l; i++) {
                if (classNames[i] !== className) {
                    newClassNames.push(classNames[i]);
                }
            }
            element.className = newClassNames.join(' ');
        }
    },
    loadCss: function (file) {
        var link = document.createElement("link");
        link.href = file;
        link.type = "text/css";
        link.rel = "stylesheet";
        link.media = "screen,print";

        document.getElementsByTagName("head")[0].appendChild(link);
    }
};
},{}],9:[function(require,module,exports){
module.exports = function(protoProps) {
    var result = function () {
        if (this.construct) {
            this.construct.apply(this, arguments);
        }
    };

    result.prototype = result;
    Object.keys(protoProps).forEach(function(key) {
        result.prototype[key] = protoProps[key];
    });

    return result;
};

},{}],10:[function(require,module,exports){
var uid = require('./uid');

module.exports = require('./createClass')({
    construct: function(origin, windowObject) {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function(e) {
            var origin = e.origin || e.originalEvent.origin;
            if (e.source === this.window && origin === this.origin || this.origin === '*') {
                this.handle(e.data);
            }
        }.bind(this), false);

        this.origin = origin;
        this.window = windowObject;
        this.servers = {};
        this._handlers = {};
    },
    registerServer: function (name, object) {
        this.servers[name] = object;
    },
    _createHandler: function() {
        var handler = { callbacks: [] };
        handler.then = function (callback) {
            if (handler.hasOwnProperty('_result')) {
                callback(handler._result);
            } else {
                handler.callbacks.push(callback);
            }
            return handler;
        };
        return handler;
    },
    call: function(method) {
        var arguments = Array.prototype.slice.call(arguments, 1);
        var id = uid(), handler = this._createHandler();
        this._handlers[id] = handler;
        this.window.postMessage({id: id, method: method, arguments: arguments}, this.origin);
        return handler;
    },
    handle: function(message) {
        if (message.method === 'resolve') {
            if (this._handlers[message.id]) {
                var handler = this._handlers[message.id];
                for (var i = 0, l = handler.callbacks.length; i < l; i++) {
                    handler.callbacks[i](message.result);
                }
                handler._result = message.result;
                delete this._handlers[message.id];
            }
        } else {
            var methodPath = message.method.split('.');
            var method = methodPath.pop();
            var target = this.servers;
            while (target && methodPath.length) {
                target = target[methodPath.shift()];
            }
            if (!target || !target[method]) {
                throw 'Unknown method "' + message.method + '"';
            }
            var result = target[method].apply(target, message.arguments);
            var resolve = function(res) {
                // It might occure, that the id is reset, when the target frame is removed
                if (message.id) {
                    this.window.postMessage({method: 'resolve', id: message.id, result: res}, this.origin);
                }
            }.bind(this);
            if (typeof result === 'function') {
                result(resolve);
            } else {
                resolve(result);
            }
        }
    }
});

},{"./createClass":9,"./uid":11}],11:[function(require,module,exports){
module.exports = function uid () {
    return '' + Math.random().toString(36).substr(2, 9);
};

},{}]},{},[7])(7)
});

